<template>
  <b-modal
      v-model="isDownloadReportModalActive"
      title="Укажите фильтры для отчета"
      ok-title="Выгрузить отчет"
      cancel-title="Отмена"
      no-close-on-backdrop
      no-close-on-esc
      @close="(bvModalEvt) => { bvModalEvt.preventDefault(); $emit('is-download-report-modal-active', false);}"
      @cancel="(bvModalEvt) => { bvModalEvt.preventDefault(); $emit('is-download-report-modal-active', false);}"
      @ok="handleOk"
      :hide-footer = dataLoading
    >
      <template v-if="dataLoading">

        <div class="text-center my-5">
            <b-spinner
                    class="mr-1 align-middle"
                    variant="primary"
            />
             <strong>Загрузка данных ...</strong>
          </div>
      </template>
      <slot v-if="!dataLoading" name="form"></slot>
    </b-modal>
</template>

<script>
import { BModal, BSpinner } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'


import useReportDownloadModal from './useReportDownloadModal'


export default {

  components: {
    BModal,
    BSpinner

  },

  directives: {
      Ripple,
  },

  props: {
    isDownloadReportModalActive: {
      type: Boolean,
      required: true,
    },
    downloadReportModalFormData: {
      type: Object,
      required: true,
    },
    reportObject: {
      type: Object,
      required: true,
    },
    requestDataConstructor: {
      type: Function,
      required: true,
    },
    downloadDataUrl: {
      type: String,
      required: true,
    }
  },
  setup(props, {emit}) {
    const {dataLoading, downloadData } = useReportDownloadModal()

    const handleOk = (bvModalEvt) => {

      bvModalEvt.preventDefault()

      downloadData( props.downloadDataUrl, props.reportObject, props.downloadReportModalFormData, props.requestDataConstructor, ()=> {
          emit('is-download-report-modal-active', false)
      })
    }

    return {
      dataLoading,
      handleOk
    }
  }

}
</script>
